"use clent";

import React from "react";
import "./styles.css";
import "../common.css";
import { Header } from "../../header-new/header";

export const MainScreen = ({
  isHeaderOnLight = false,
  backgroundColor = "#fff",
  titleColor = "#000",
  textColor = "#000",
  borderRadius = 0,
  variant = "",
  picSource = "/img/articles-img/ux-ui-problems-web3/ui-ux-problem-header.png",
  picBackgoundSource = "/img/mc-bg.png",
}) => {
  return (
    <div
      className="wrapper"
      style={{
        background: backgroundColor,
        color: textColor,
        borderRadius: borderRadius,
        marginBottom: borderRadius ? borderRadius * -1 : 0,
        position: borderRadius ? "relative" : "static",
      }}
    >
      <Header onLight={isHeaderOnLight} />

      <div className="container">
        <a href="/" className="allProjectLink">
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="Arrow 4"
              d="M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM17 9H1V7H17V9Z"
              fill="currentColor"
            />
          </svg>
          Назад
        </a>

        {variant === "right" ? (
          <div className="grid">
            <div
              className={
                variant ? "titleBlock titleBlock--short" : "titleBlock"
              }
            >
              <h1 className="h1" style={{ color: titleColor }}>
                4 фатальных ошибки при проектировании криптопроектов, которые
                будут стоить вам времени, денег, клиентов и репутации
              </h1>
            </div>

            <img src="/img/ms4.png" alt="" className="picture" />
          </div>
        ) : (
          <>
            <div
              className={
                variant ? "titleBlock titleBlock--short" : "titleBlock"
              }
            >
              {/* <div className="subtitle">SharxDC</div> */}

              <h1 className="h1" style={{ color: titleColor }}>
                <span className="blueTitle"> 4 фатальных ошибки </span>
                при проектировании криптопроектов, которые будут стоить
                вам времени, денег, клиентов и репутации
              </h1>
            </div>

            {variant === "aside" ? (
              <img src={picSource} alt="" className="picture picture--aside" />
            ) : variant === "double" ? (
              <div className="doublepics">
                <img
                  src={picBackgoundSource}
                  alt=""
                  className="double__background"
                />
                <img src={picSource} alt="" className="double__foreground" />
              </div>
            ) : (
              <img src={picSource} alt="" className="picture" />
            )}
          </>
        )}
      </div>
    </div>
  );
};
